export enum WidgetType {
  Rent = 'rent',
  Rooms = 'rooms',
  Schedule = 'schedule',
  Subscriptions = 'subscriptions',
  Courses = 'courses',
  Coaches = 'coaches',
  Payment = 'payment',
  PurchaseSubscription = 'purchaseSubscription',
  Certificates = 'certificates',
  IndividualBooking = 'individualBooking',
}

export interface WidgetSettings {
  widgetId: string;
  clubId: string;
  widgetType: WidgetType;
  timeZone: number;
  settings: WidgetConfigBase;
  dependenceWidgetId: string;
  culture?: string;
  courseId?: string;
  TimeMatrix?: any[];
  rooms?: any[];
}

export interface WidgetConfigBase {
  [key: string]: any;
  style: string;
}

export interface IPaymentStatus {
  status: string;
}

export enum PaymentStatus {
  Success = 'Success',
  Fail = 'Fail',
  Unknown = 'Unknown',
}

export interface CertificatesWidgetSettings extends WidgetSettings {
  settings: any;
}

export interface ScheduleWidgetConfig extends WidgetConfigBase {
  // TODO: настройка для отображения пустых строк в расписании
  showRoomFilter: boolean;
  showGroupFilter: boolean;
  showCoursesFilter: boolean;
  showCoachesFilter: boolean;
  showTrainingCategoryFilter: boolean;
  showLevelFilter: boolean;
  showClubNet: boolean;
  showComments: boolean;
  roomId: string;
  disableSubscribeOnClass: boolean;
  showBirthday: boolean;
  isBookingScheduleAllowed: boolean;
  isSubscriptionSellAllowed: boolean;
  scheduleWidgetId?: string;
  widgetName: string;
  dictionaryAlias?: string;
  disableRoom: boolean;
  disableCoach: boolean;
  singleEntryForm?: boolean;
  hideSbp?: boolean;
  visibilityDescSub: VisibilityDescriptionSub;
  availableInfo: AvailableInfo;
  isFillComment: boolean;
  placeholderComment: string;
  isAllowSubPriceChange?: boolean;
  isRemoveCustomPayment: boolean;
  hidePastClasses: boolean;
  design?: 'columns' | 'tabs' | 'rows';
}

export interface ScheduleWidgetSettings extends WidgetSettings {
  settings: ScheduleWidgetConfig;
}

export interface IbCatalogItem {
  id: string;
  name: string;
}

export interface IndividualBookingWidgetConfig extends WidgetConfigBase {
  courses?: IbCatalogItem[];
  coaches?: IbCatalogItem[];
  rooms?: IbCatalogItem[];
  allowRoomSelection?: boolean;
  /** Запись без абонемента (оплата наличными в клубе), строка В макета. */
  allowBookingWithoutSubscription?: boolean;
  split30Minutes?: boolean;
  showAuthGoogle?: boolean;
  showAuthApple?: boolean;
  showAuthFacebook?: boolean;
  showAuthVK?: boolean;
  showAuthPhone?: boolean;
  showAuthEmail?: boolean;
  showAuthPush?: boolean;
  showAuthLoginAndPassword?: boolean;
}

export interface IndividualBookingWidgetSettings extends WidgetSettings {
  settings: IndividualBookingWidgetConfig;
}

export interface VisitWidgetConfig extends WidgetConfigBase {
  showBookedFree: string;
  showComments: boolean;
  activeDisplayType: string;
}

export interface VisitWidgetSettings extends WidgetSettings {
  settings: VisitWidgetConfig;
}

export enum PaymentGateway {
  Unknown = 'Unknown',
  Sbp = 'Sbp',
}

export enum VisibilityDescriptionSub {
  HideEveryone,
  Desktop,
  Mobile,
  ShowEveryone,
}

export enum AvailableInfo {
  Everyone,
  Registered,
  Anonymous,
}

export interface IMouse {
  isMouseDown: boolean;
  isMouseMove: boolean;
  positionX: number;
  positionY: number;
}

export interface IScroll {
  isScrolling: boolean;
  scrollBarWidth: number;
  scrollButtonWidth: number;
  scrollBarPositionX: number;
  scrollButtonPositionX: number;
}

export interface ITableHeader {
  position: number;
  offset: number;
  stick: boolean;
}
